module.exports = __webpack_public_path__ + "static/media/ecoleta.13969fdf.png";